import { MiModalConfirm } from "@miplatform/components";
import { IBidResponse } from "@miplatform/types";
import { useTheme } from "@mui/material";

export function DeleteTemplateModal({
  open,
  closeModal,
  selectedTemplate,
  deleteBid,
}: DeleteTemplateModalProps) {
  const theme = useTheme();

  const handleDeleteTemplate = async () => {
    if (selectedTemplate) {
      await deleteBid(selectedTemplate);
      closeModal();
    }
  };

  return (
    <MiModalConfirm
      open={open}
      title="Delete Area Template?"
      description={
        <>
          Are you sure you want to delete{" "}
          <span
            style={{
              fontWeight: theme.fontWeight.semiBold,
              color: theme.palette.primary.main,
            }}
          >
            {selectedTemplate?.name}
          </span>{" "}
          area template?
        </>
      }
      handleNegative={closeModal}
      handlePositive={handleDeleteTemplate}
    />
  );
}

interface DeleteTemplateModalProps {
  open: boolean;
  closeModal: () => void;
  selectedTemplate: IBidResponse | null;
  deleteBid: (data: IBidResponse) => Promise<void>;
}
